<template>
  <article :class="['test-page']">
    <h1 style="text-align: center;">
      count : {{this.$store.state.count}}
    </h1>
    <button @click="changeVX()">减少</button>
    <button @click="goback()">返回</button>
    <test-header
    :titleText='titleText'
    ></test-header>

    <test-inputs
    :inputItems='inputItems'
    :className='className'
    ></test-inputs>

  </article>
</template>

<script>
  import Footer from './child-components/Footer'
  import Header from './child-components/Header'
  import InputInfo from './child-components/InputInfo'
  import store from '@/vuex/store.js'

  export default {
    name:"test-page",
    store,
    data(){
      return {
        // header title,val:""
        titleText:"test",
        className:"test-wrap",
        inputItems:[
          {id:1,title:"联系人",type:"text",ChildclassName:"link-man-wrap",disabled:false,placeholder:"请输入您的真实姓名"},
          {id:1,title:"联系电话",type:"number",ChildclassName:"phone-wrap",disabled:false,placeholder:"请输入您的真实姓名"},
        ],
      }
    },
    components:{
      "test-footer":Footer,
      "test-header":Header,
      "test-inputs":InputInfo,
    },
    methods:{
      changeVX(){
        store.commit('subCount');
      },
      goback(){
        this.$router.go(-1);
      }
    },

  }
</script>

<style scoped lang="less">

  @import '.././style/variable';

</style>



// WEBPACK FOOTER //
// src/components/TestPage.vue